import { CatalogPreview } from "../../../api/pricelist.types";
import { PricelistCatalogsAction } from "./pricelist.catalogs.types";

export const pricelistCatalogsRequest = (): PricelistCatalogsAction => ({ type: 'PRICELIST_CATALOGS_REQUEST' })

export const pricelistCatalogsSuccess = (services: CatalogPreview[]): PricelistCatalogsAction => ({ type: 'PRICELIST_CATALOGS_SUCCESS', params: services })

export const pricelistCatalogsFailure = (error?: any) => ({ type: 'PRICELIST_CATALOGS_FAILURE' } as const)